import { createActionCreator } from 'deox';

export const addMaintainer = createActionCreator('ADD_MAINTAINER', (resolve) => (account: string) => resolve(account));

export const removeMaintainer = createActionCreator(
  'REMOVE_MAINTAINER',
  (resolve) => (account: string) => resolve(account),
);

export const setMaintainerStatus = createActionCreator(
  'GET_MAINTAINER_STATUS',
  (resolve) => (isAdmin: boolean) => resolve(isAdmin),
);

export const setMaintainers = createActionCreator(
  'GET_MAINTAINERS',
  (resolve) => (admins: Array<string>) => resolve(admins),
);
